import * as React from 'react';
import { render } from 'react-dom';

export default function initAgentBonusTooltip() {
  (window as any).renderAgentBonusTooltip = function(container: Element, isDeveloper: boolean) {
    require.ensure(['./components/agent_bonus_tooltip.tsx'], () => {
      const AgentBonusTooltip = require('./components/agent_bonus_tooltip').default;
      
      render(
        <AgentBonusTooltip isDeveloper={isDeveloper} />,
        container,
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/bundles/agent_bonus/index.tsx